import React, { useContext, useEffect } from "react";
import CardAgendado from "../../../components/Cards/CardAgendado/Card";
import { Col } from "react-bootstrap";
import { MainContext } from "../../../context/MainContext";
import { PaginationLayout } from "../../PaginationLayout";

const ClassesThatWillHappenTomorrowListComponent: React.FC = ({}) => {
  const {
    classes, 
    currentPage, 
    loadClassesWillHappenTomorrow,
    getSearchInputTextValue
  } = useContext(MainContext)

  useEffect(() => {
    let isFiltering:boolean = getSearchInputTextValue()!==""

    loadClassesWillHappenTomorrow(currentPage,isFiltering)
  }, [currentPage]);

  return (
    <PaginationLayout
      reload={loadClassesWillHappenTomorrow}
    >
      {classes.map((item: any) => (
        <Col md={"auto"} className="pe-0">
          <CardAgendado
            countStudents={item.countStudents}
            date={item.date}
            descrpiton={item.description}
            startTime={item.startTime}
            endTime={item.endTime}
            name={item.name}
            teachers={item.teachers}
            joinUrl={item.joinUrl}
            countTeachers={item.countTeachers}
          />
        </Col>
      ))}
    </PaginationLayout>
  );
};
export default ClassesThatWillHappenTomorrowListComponent;
